import { useEffect } from 'react';

const useIntersectionObserver = () => {
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    // Povećavamo interval ili koristimo proveru da li su elementi tu
    const observeElements = () => {
      const fadeElements = document.querySelectorAll('.fade-in');
      fadeElements.forEach(el => observer.observe(el));
    };

    // Pokušaj odmah, i još jednom nakon kratkog vremena
    observeElements();
    const timer = setTimeout(observeElements, 500);

    return () => {
      observer.disconnect();
      clearTimeout(timer);
    };
  }, []);
};

export default useIntersectionObserver;